import moment from "moment";
import "moment/locale/ko";
import { TimeForm } from "../../components/dialog/delivery-dialog/DropOffActionFormCard";

export const timeFormat = (datetime?: string | Date | null) => {
    return datetime ? moment(datetime).format("HH:mm") : "";
};

export const dateFormat = (datetime?: string | Date) => {
    return datetime ? moment(datetime).format("YYYY-MM-DD") : "";
};

export const datetimeFormat = (datetime?: string | Date) => {
    return datetime ? moment(datetime).format("YYYY-MM-DD HH:mm") : "";
};

export const scheduleDateFormat = (datetime?: string | Date) => {
    return datetime ? moment(datetime).format("YY/MM/DD") : "";
};

export const convertYYYYMMDDddddFormat = (datetime?: string | Date) => {
    return datetime ? moment(datetime).format("YYYY.MM.DD dddd") : "";
};

export const convertYYYYMMDDddFormat = (datetime?: string | Date) => {
    return datetime ? moment(datetime).format("YYYY/MM/DD(dd)") : "";
};

export function addLeadingZero(number: string) {
    // 주어진 숫자가 10보다 작으면 앞에 0을 붙여 두 자리로 만듭니다.
    return Number(number) < 10 ? "0" + number : number.toString();
}

export const initTimePicker = () => {
    const initTime = new Date();
    initTime.setSeconds(0);
    initTime.setMilliseconds(0);
    return initTime.toISOString();
};

export const monthAgo = () => {
    const date = new Date();
    const month = date.getMonth();
    return new Date(new Date().setMonth(month - 1));
};

export const deliveryGroupOrderTimeFormat = (datetime: string) => {
    const dateTimeArray = datetime.split("|");
    const dateTimeFormat = dateTimeArray[dateTimeArray.length - 1];
    return dateTimeFormat ? moment(dateTimeFormat).format("HH:mm") : "";
};

// 19960601 -> 1996-06-01
export const convertToBirthDay = (birthday: string) => {
    return `${birthday.slice(0, 4)}-${birthday.slice(4, 6)}-${birthday.slice(6)}`;
};

export const convertToTimeLimited = (timeForm: TimeForm, dateToWork: Date) => {
    const hour = Number(timeForm.hour);
    const minute = Number(timeForm.minute);

    let parsedHour: number;
    if (timeForm.type === "오후") {
        parsedHour = hour < 12 ? hour + 12 : hour;
    } else {
        parsedHour = timeForm.type === "오전" && hour === 12 ? 0 : hour;
    }

    const parsedDate = new Date(
        dateToWork.getFullYear(),
        dateToWork.getMonth(),
        dateToWork.getDate(),
        parsedHour,
        minute
    );

    return parsedDate;
};

export const getMidday = (dateTimeString: string) => {
    const hour = moment(dateTimeString).format("H");
    return Number(hour) < 12 ? "오전" : "오후";
};

export const getHour = (dateTimeString: string) => {
    return dateTimeString ? moment(dateTimeString).format("h") : "";
};

export const getMinute = (dateTimeString: string) => {
    return dateTimeString ? String(moment(dateTimeString).minutes()) : "";
};

export const convertISOString = (dateTimeString: string) => {
    return moment(dateTimeString, "YYYY-MM-DD HH:mm:ss").toISOString();
};

export const todayYYYYMMDD = moment().format("YYYY-MM-DD");

export const formatZeroLeadTime = (input: string): string => {
    const parts = input.split(':');

    if (parts.length !== 2) {
        throw new Error('Invalid time format');
    }

    const hour = parts[0].padStart(2, '0');
    const minute = parts[1].padStart(2, '0');

    return `${hour}:${minute}`;
}

export const removeLeadingZeros = (time: string): string => {
    return parseInt(time, 10).toString();
}

export function getCurrentFormattedTime() {
    return moment().format('YYYY.MM.DD HH:mm');
}

export const isSameDay = (date1?: Date, date2?: Date): boolean => {
    if (!date1 || !date2) return false;

    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};
